module.exports = __webpack_public_path__ + "static/media/sketchfab-search.17c1bba8.jpg";